<template>
  <div
    class="main--text">
    <Loading
      v-if="isLoading"/>
    <v-container
      fluid
      v-else-if="requests.length() > 0"
      class="no--vertical--padding">
      <template
        v-for="(student) in students.get()"
        >
        <v-request-from-teachers
          :key="student.id"
          :student="student"
          :requests="requestsForEach(student)"
          @accept-button-click="accept($event)"
          @deny-button-click="deny($event)"
          @info-button-click="displayProfile"
          />
      </template>
    </v-container>
    <v-container
      fluid
      v-else
      class="no--vertical--padding"
      >
      <v-row
        justify=center>
        <v-col
          md=8
          sm=10
          cols=12>
          <v-card>
            <v-container
              fluid>
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h4>現在リクエストはありません。</h4>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-request-teacher-info
      v-if="teacher"
      :enable="profileDialog"
      :teacher="teacher"
      @close-button-click="closeProfile"/>
    <v-snackbar
      v-model="resultBar"
      top>
      <span>{{resultMessage}}</span>
      <v-btn
        dark
        text
        @click="resultBar=false">閉じる</v-btn>
    </v-snackbar>
    <v-progress
      v-model="inProgress"/>
  </div>
</template>

<script>
import { firestore } from "@/repository/client/firestore"
import { RequestRepository } from "@/repository/RequestRepository"
import { AcceptRequestService } from '@/service/request/accept-request'
import VRequestFromTeachers from "@/components/organisms/parent/VRequestFromTeachers.vue"
import VRequestTeacherInfo from "@/components/organisms/parent/VRequestTeacherInfo.vue"
import Loading from "@/components/organisms/Loading.vue"
import VProgress from '@/components/organisms/VProgress.vue'


export default {
  components: {
    VRequestFromTeachers,
    VRequestTeacherInfo,
    Loading,
    VProgress
  },
  data () {
    return {
      students: null,
      requests: null,
      requestRepo: null,
      profileDialog: false,
      teacher: null,
      isLoading: true,
      resultMessage: "",
      resultBar: false,
      inProgress: false
    }
  },
  methods: {
    async accept(request) {
      this.inProgress = true
      const service = new AcceptRequestService(firestore, this.$store.getters.parent)
      this.parent = await service.execute(request.id)
      this.requests.remove(request)
      this.$store.commit('loginAsParent', this.parent)
      this.resultMessage = "リクエストを承認しました。"
      this.inProgress = false
      this.resultBar = true
    },
    async deny(request) {
      this.inProgress = true
      const result = await this.requestRepo.deny(request)
      this.requests.remove(request)
      this.resultMessage = "リクエストを見送りました"
      this.inProgress = false
      this.resultBar = true
    },
    displayProfile(teacher) {
      this.teacher = teacher
      this.profileDialog = true
    },
    closeProfile() {
      this.profileDialog = false
      this.teacher = null
    },
    requestsForEach(student) {
      return this.requests.filterByStudentId(student.id)
    }
  },
  created: async function () {
    this.requestRepo = new RequestRepository(firestore)
    this.students = this.$store.getters.parent.students
    this.requests = await this.requestRepo.listOfInRequest(this.$store.getters.parent.uuid)
    this.isLoading = false
  }
}
</script>

<style scoped>
.no--vertical--padding {
  padding: 0px 12px;
}
</style>
